<div id="qrCodeScannerContainer" class="scannercontainer" style="position: fixed; visibility: hidden">
  <div #qrCodeScanner id="qrCodeScanner" class="scannerbox"></div>
  <div class="scannercancelbutton">
    <button mat-stroked-button type="button" class="text-button cancel" (click)="cancel()">
      {{ this.res.get('Cancel').toUpperCase() }}
    </button>
  </div>
</div>
